// 프로덕션 환경에서 안전하게 로깅하기 위한 유틸리티
const logger = {
    log: (...args: any[]) => {
        if (process.env.NODE_ENV !== "production") {
            console.log(...args);
        }
    },
    error: (...args: any[]) => {
        // 에러는 프로덕션에서도 기록
        console.error(...args);
        // TODO: 여기에 에러 추적 서비스 연동 코드 추가
    },
    warn: (...args: any[]) => {
        if (process.env.NODE_ENV !== "production") {
            console.warn(...args);
        }
    },
    info: (...args: any[]) => {
        if (process.env.NODE_ENV !== "production") {
            console.info(...args);
        }
    }
};

export default logger;
